"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyAmountDisplayWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../commonFunctions");
var journey_model_1 = require("@athena-portal/journey-model");
var journey_services_1 = require("@athena-portal/journey-services");
var CurrencyAmountDisplayWidget = /** @class */ (function (_super) {
    __extends(CurrencyAmountDisplayWidget, _super);
    function CurrencyAmountDisplayWidget(props) {
        return _super.call(this, props) || this;
    }
    CurrencyAmountDisplayWidget.prototype.render = function () {
        var style = this.getSetting("cssClass");
        var id = this.getSetting("cssId");
        var interactionField = this.getSetting("interactionField");
        var upfrontPremiumField = this.getSetting("upfrontInterestCorrectionPaymentInteractionField");
        if (!interactionField) {
            throw Error("".concat(this.props.question.type, " widget is missing 'interactionField' setting"));
        }
        var currencyValue = upfrontPremiumField !== undefined ? journey_services_1.ObjectManipulator.fetchFieldValue(interactionField, this.props.interaction) + journey_services_1.ObjectManipulator.fetchFieldValue(upfrontPremiumField, this.props.interaction) : journey_services_1.ObjectManipulator.fetchFieldValue(interactionField, this.props.interaction);
        return (id ? ((0, jsx_runtime_1.jsx)("div", { id: id, className: "currency-amount-display ".concat(style), children: (0, commonFunctions_1.getAmountWithDecimalDigits)(currencyValue) })) : ((0, jsx_runtime_1.jsx)("div", { className: "currency-amount-display ".concat(style), children: (0, commonFunctions_1.getAmountWithDecimalDigits)(currencyValue) })));
    };
    CurrencyAmountDisplayWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "cssClass", type: journey_model_1.TypeDescriptions.String },
            { name: "cssId", type: journey_model_1.TypeDescriptions.String },
            { name: "interactionField", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], CurrencyAmountDisplayWidget);
    return CurrencyAmountDisplayWidget;
}(plugin_journey_1.WidgetBase));
exports.CurrencyAmountDisplayWidget = CurrencyAmountDisplayWidget;
//# sourceMappingURL=CurrencyAmountDisplayWidget.js.map